/* eslint-disable no-shadow */

export namespace BackendPublicEnums {

export enum AccountRegisterLanguageEnum {
'CS' = 'cs',
'SK' = 'sk',
'EN' = 'en',
'PL' = 'pl',
'HU' = 'hu',
'RO' = 'ro',
}

export enum AmountOfShippingsEnum {
'VALUE_1' = 1,
'VALUE_2' = 2,
'VALUE_3' = 3,
'VALUE_4' = 4,
'VALUE_5' = 5,
}

export enum BillingCurrencyEnum {
'CZK' = 'CZK',
'EUR' = 'EUR',
}

export enum CountryEnum {
'AF' = 'AF',
'AX' = 'AX',
'AL' = 'AL',
'DZ' = 'DZ',
'AS' = 'AS',
'AD' = 'AD',
'AO' = 'AO',
'AI' = 'AI',
'AQ' = 'AQ',
'AG' = 'AG',
'AR' = 'AR',
'AM' = 'AM',
'AW' = 'AW',
'AU' = 'AU',
'AT' = 'AT',
'AZ' = 'AZ',
'BS' = 'BS',
'BH' = 'BH',
'BD' = 'BD',
'BB' = 'BB',
'BY' = 'BY',
'BE' = 'BE',
'BZ' = 'BZ',
'BJ' = 'BJ',
'BM' = 'BM',
'BT' = 'BT',
'BO' = 'BO',
'BQ' = 'BQ',
'BA' = 'BA',
'BW' = 'BW',
'BV' = 'BV',
'BR' = 'BR',
'IO' = 'IO',
'BN' = 'BN',
'BG' = 'BG',
'BF' = 'BF',
'BI' = 'BI',
'CV' = 'CV',
'KH' = 'KH',
'CM' = 'CM',
'CA' = 'CA',
'KY' = 'KY',
'CF' = 'CF',
'TD' = 'TD',
'CL' = 'CL',
'CN' = 'CN',
'CX' = 'CX',
'CC' = 'CC',
'CO' = 'CO',
'KM' = 'KM',
'CD' = 'CD',
'CG' = 'CG',
'CK' = 'CK',
'CR' = 'CR',
'CI' = 'CI',
'HR' = 'HR',
'CU' = 'CU',
'CW' = 'CW',
'CY' = 'CY',
'CZ' = 'CZ',
'DK' = 'DK',
'DJ' = 'DJ',
'DM' = 'DM',
'DO' = 'DO',
'EC' = 'EC',
'EG' = 'EG',
'SV' = 'SV',
'GQ' = 'GQ',
'ER' = 'ER',
'EE' = 'EE',
'ET' = 'ET',
'FK' = 'FK',
'FO' = 'FO',
'FJ' = 'FJ',
'FI' = 'FI',
'FR' = 'FR',
'GF' = 'GF',
'PF' = 'PF',
'TF' = 'TF',
'GA' = 'GA',
'GM' = 'GM',
'GE' = 'GE',
'DE' = 'DE',
'GH' = 'GH',
'GI' = 'GI',
'GR' = 'GR',
'GL' = 'GL',
'GD' = 'GD',
'GP' = 'GP',
'GU' = 'GU',
'GT' = 'GT',
'GG' = 'GG',
'GN' = 'GN',
'GW' = 'GW',
'GY' = 'GY',
'HT' = 'HT',
'HM' = 'HM',
'VA' = 'VA',
'HN' = 'HN',
'HK' = 'HK',
'HU' = 'HU',
'IS' = 'IS',
'IN' = 'IN',
'ID' = 'ID',
'IR' = 'IR',
'IQ' = 'IQ',
'IE' = 'IE',
'IM' = 'IM',
'IL' = 'IL',
'IT' = 'IT',
'JM' = 'JM',
'JP' = 'JP',
'JE' = 'JE',
'JO' = 'JO',
'KZ' = 'KZ',
'KE' = 'KE',
'KI' = 'KI',
'KP' = 'KP',
'KR' = 'KR',
'KW' = 'KW',
'KG' = 'KG',
'LA' = 'LA',
'LV' = 'LV',
'LB' = 'LB',
'LS' = 'LS',
'LR' = 'LR',
'LY' = 'LY',
'LI' = 'LI',
'LT' = 'LT',
'LU' = 'LU',
'MO' = 'MO',
'MK' = 'MK',
'MG' = 'MG',
'MW' = 'MW',
'MY' = 'MY',
'MV' = 'MV',
'ML' = 'ML',
'MT' = 'MT',
'MH' = 'MH',
'MQ' = 'MQ',
'MR' = 'MR',
'MU' = 'MU',
'YT' = 'YT',
'MX' = 'MX',
'FM' = 'FM',
'MD' = 'MD',
'MC' = 'MC',
'MN' = 'MN',
'ME' = 'ME',
'MS' = 'MS',
'MA' = 'MA',
'MZ' = 'MZ',
'MM' = 'MM',
'NA' = 'NA',
'NR' = 'NR',
'NP' = 'NP',
'NL' = 'NL',
'NC' = 'NC',
'NZ' = 'NZ',
'NI' = 'NI',
'NE' = 'NE',
'NG' = 'NG',
'NU' = 'NU',
'NF' = 'NF',
'MP' = 'MP',
'NO' = 'NO',
'OM' = 'OM',
'PK' = 'PK',
'PW' = 'PW',
'PS' = 'PS',
'PA' = 'PA',
'PG' = 'PG',
'PY' = 'PY',
'PE' = 'PE',
'PH' = 'PH',
'PN' = 'PN',
'PL' = 'PL',
'PT' = 'PT',
'PR' = 'PR',
'QA' = 'QA',
'RE' = 'RE',
'RO' = 'RO',
'RU' = 'RU',
'RW' = 'RW',
'BL' = 'BL',
'SH' = 'SH',
'KN' = 'KN',
'LC' = 'LC',
'MF' = 'MF',
'PM' = 'PM',
'VC' = 'VC',
'WS' = 'WS',
'SM' = 'SM',
'ST' = 'ST',
'SA' = 'SA',
'SN' = 'SN',
'RS' = 'RS',
'SC' = 'SC',
'SL' = 'SL',
'SG' = 'SG',
'SX' = 'SX',
'SK' = 'SK',
'SI' = 'SI',
'SB' = 'SB',
'SO' = 'SO',
'ZA' = 'ZA',
'GS' = 'GS',
'SS' = 'SS',
'ES' = 'ES',
'LK' = 'LK',
'SD' = 'SD',
'SR' = 'SR',
'SJ' = 'SJ',
'SZ' = 'SZ',
'SE' = 'SE',
'CH' = 'CH',
'SY' = 'SY',
'TW' = 'TW',
'TJ' = 'TJ',
'TZ' = 'TZ',
'TH' = 'TH',
'TL' = 'TL',
'TG' = 'TG',
'TK' = 'TK',
'TO' = 'TO',
'TT' = 'TT',
'TN' = 'TN',
'TR' = 'TR',
'TM' = 'TM',
'TC' = 'TC',
'TV' = 'TV',
'UG' = 'UG',
'UA' = 'UA',
'AE' = 'AE',
'GB' = 'GB',
'UM' = 'UM',
'US' = 'US',
'UY' = 'UY',
'UZ' = 'UZ',
'VU' = 'VU',
'VE' = 'VE',
'VN' = 'VN',
'VG' = 'VG',
'VI' = 'VI',
'WF' = 'WF',
'EH' = 'EH',
'YE' = 'YE',
'ZM' = 'ZM',
'ZW' = 'ZW',
}

export enum CurrencyEnum {
'AUD' = 'AUD',
'BGN' = 'BGN',
'CAD' = 'CAD',
'CHF' = 'CHF',
'CZK' = 'CZK',
'DKK' = 'DKK',
'EUR' = 'EUR',
'GBP' = 'GBP',
'HRK' = 'HRK',
'HUF' = 'HUF',
'ILS' = 'ILS',
'JPY' = 'JPY',
'MXN' = 'MXN',
'NOK' = 'NOK',
'PLN' = 'PLN',
'RON' = 'RON',
'SEK' = 'SEK',
'SGD' = 'SGD',
'THB' = 'THB',
'UAH' = 'UAH',
'USD' = 'USD',
}

export enum CustomFieldTypeEnum {
'BANK_ACCOUNT' = 'BANK_ACCOUNT',
'CHAR' = 'CHAR',
'DATE' = 'DATE',
'MULTILINE' = 'MULTILINE',
'NUMERIC' = 'NUMERIC',
'BOOL' = 'BOOL',
'SELECT' = 'SELECT',
'SELECTMULTI' = 'SELECTMULTI',
'URL' = 'URL',
'FILE' = 'FILE',
'CZECH_BANK_ACCOUNT' = 'CZECH_BANK_ACCOUNT',
'IBAN' = 'IBAN',
}

export enum CustomerPaidShippingRatingRatingIntuitivityEnum {
'YES' = 'YES',
'MAYBE' = 'MAYBE',
'NO' = 'NO',
}

export enum CustomerPaidShippingRatingRatingProblemsEnum {
'YES' = 'YES',
'NO' = 'NO',
}

export enum CustomerPaidShippingRatingRatingSatisfactionEnum {
'VALUE_2' = 2,
'VALUE_1' = 1,
'VALUE_0' = 0,
}

export enum CustomerRatingEnum {
'VALUE_0' = 0,
'VALUE_1' = 1,
'VALUE_2' = 2,
}

export enum DropOffBranchShippingProvidersEnum {
'ZASILKOVNA' = 'ZASILKOVNA',
'MY_GLS_DROPOFF' = 'MY_GLS_DROPOFF',
'DPD_DROPOFF' = 'DPD_DROPOFF',
'RETINO_PPL' = 'RETINO_PPL',
'CUSTOMER_RETINO_PPL' = 'CUSTOMER_RETINO_PPL',
'CUSTOMER_RETINO_GLS_DROPOFF' = 'CUSTOMER_RETINO_GLS_DROPOFF',
'LIFTAGO_RETINO_PPL' = 'LIFTAGO_RETINO_PPL',
'GLS_DROPOFF_PL' = 'GLS_DROPOFF_PL',
'RETURN_CONNECT' = 'RETURN_CONNECT',
'DHL_DROPOFF' = 'DHL_DROPOFF',
}

export enum ExchangeTypeEnum {
'SWAP' = 'SWAP',
'CREDIT' = 'CREDIT',
}

export enum ExclusionEnum {
'NO_EXCHANGE' = 'NO_EXCHANGE',
}

export enum FileUploadCreateStatusEnum {
'UPLOADED' = 'UPLOADED',
'FAILED_UPLOAD' = 'FAILED_UPLOAD',
'UPLOADING' = 'UPLOADING',
}

export enum ItemTypeEnum {
'VALUE_1' = 1,
'VALUE_2' = 2,
'VALUE_3' = 3,
'VALUE_4' = 4,
'VALUE_5' = 5,
'VALUE_6' = 6,
}

export enum LabelTypeEnum {
'PRINT_LABEL' = 'PRINT_LABEL',
'QR_CODE' = 'QR_CODE',
'DROP_OFF_CODE' = 'DROP_OFF_CODE',
}

export enum LabelTypesEnum {
'PRINT_LABEL' = 'PRINT_LABEL',
'QR_CODE' = 'QR_CODE',
'DROP_OFF_CODE' = 'DROP_OFF_CODE',
}

export enum LanguageEnum {
'EN' = 'en',
'DE' = 'de',
'DE-AT' = 'de-at',
'DE-CH' = 'de-ch',
'CS' = 'cs',
'SK' = 'sk',
'PL' = 'pl',
'HU' = 'hu',
'RO' = 'ro',
'ES' = 'es',
'IT' = 'it',
'IT-CH' = 'it-ch',
'FR' = 'fr',
'FR-CH' = 'fr-ch',
'FR-BE' = 'fr-be',
'HR' = 'hr',
'BG' = 'bg',
'SL' = 'sl',
'EL' = 'el',
'NL' = 'nl',
'NL-BE' = 'nl-be',
'NB' = 'nb',
'LV' = 'lv',
'LT' = 'lt',
'ET' = 'et',
'DA' = 'da',
'SV' = 'sv',
'FI' = 'fi',
'PT' = 'pt',
'UK' = 'uk',
'SR' = 'sr',
}

export enum NoShippingReasonEnum {
'DELIVERY_IN_PERSON' = 'DELIVERY_IN_PERSON',
'HIGH_PRICES' = 'HIGH_PRICES',
'MISSING_SHIPPING_TYPE' = 'MISSING_SHIPPING_TYPE',
'BAD_EXPERIENCE' = 'BAD_EXPERIENCE',
'OTHER' = 'OTHER',
}

export enum PlatformIntegrationDataStateEnum {
'NEW' = 'NEW',
'COMPLETED' = 'COMPLETED',
}

export enum PlatformIntegrationDataTypeEnum {
'SHOPTET_API' = 'SHOPTET_API',
'RETINO_XML' = 'RETINO_XML',
'PRESTASHOP_16' = 'PRESTASHOP_16',
'UPGATES_API' = 'UPGATES_API',
'SHOPIFY_PRIVATE' = 'SHOPIFY_PRIVATE',
'SHOPIFY_API' = 'SHOPIFY_API',
'SIMPLIA_API' = 'SIMPLIA_API',
'SHOPRENTER_API' = 'SHOPRENTER_API',
'WEBAREAL_API' = 'WEBAREAL_API',
'SHOPWARE_5' = 'SHOPWARE_5',
'SHOPWARE_6' = 'SHOPWARE_6',
'BYZNYSWEB_API' = 'BYZNYSWEB_API',
'WOOCOMMERCE_API' = 'WOOCOMMERCE_API',
'RETINO_ORDERS_API' = 'RETINO_ORDERS_API',
'UNAS_API' = 'UNAS_API',
'ESHOP_RYCHLE_API' = 'ESHOP_RYCHLE_API',
'IDOSELL_API' = 'IDOSELL_API',
}

export enum PortalFormProgressStateEnum {
'PRODUCTS' = 'PRODUCTS',
'EXCHANGE_SUMMARY' = 'EXCHANGE_SUMMARY',
'SHIPPING' = 'SHIPPING',
'REFUNDS' = 'REFUNDS',
'CUSTOMER' = 'CUSTOMER',
'SUMMARY' = 'SUMMARY',
'RESULT' = 'RESULT',
}

export enum ProductCustomFieldTypeEnum {
'CHAR' = 'CHAR',
'MULTILINE' = 'MULTILINE',
'DATE' = 'DATE',
'SELECT' = 'SELECT',
'FILE' = 'FILE',
'LINK' = 'LINK',
}

export enum ProductFieldEnum {
'MANUFACTURER' = 'manufacturer',
'CATEGORY' = 'category',
'VARIANT' = 'variant',
'PRODUCT_ID' = 'product_id',
'EAN' = 'ean',
'SERIAL' = 'serial',
}

export enum RatingShippingProviderReasonEnum {
'LOW_PRICE' = 'LOW_PRICE',
'SPEED' = 'SPEED',
'MANY_PARCEL_SHOPS' = 'MANY_PARCEL_SHOPS',
'OTHER' = 'OTHER',
}

export enum RefundOptionTypeEnum {
'TO_BANK_ACCOUNT' = 'TO_BANK_ACCOUNT',
'VOUCHER' = 'VOUCHER',
'CUSTOM' = 'CUSTOM',
'WEBHOOK' = 'WEBHOOK',
}

export enum SelectedProductsEnum {
'MANAGER' = 'MANAGER',
'TRACKING' = 'TRACKING',
}

export enum ShippingPriceEnum {
'BEFOREDISCOUNT' = 'beforeDiscount',
'CART' = 'cart',
'FREE' = 'free',
}

export enum ShippingProvidersEnum {
'CUSTOM' = 'CUSTOM',
'DHL24_PICKUP' = 'DHL24_PICKUP',
'DHL24_DROP_OFF' = 'DHL24_DROP_OFF',
'DHL_FREIGHT_PICKUP' = 'DHL_FREIGHT_PICKUP',
'DHL_INTERNATIONAL_DROPOFF' = 'DHL_INTERNATIONAL_DROPOFF',
'DPD_BELGIUM_DROPOFF' = 'DPD_BELGIUM_DROPOFF',
'DPD_GEO_API_DROPOFF' = 'DPD_GEO_API_DROPOFF',
'DPD_GEO_API_PICKUP' = 'DPD_GEO_API_PICKUP',
'DPD_HU_DROPOFF' = 'DPD_HU_DROPOFF',
'DPD_HU_PICKUP' = 'DPD_HU_PICKUP',
'DPD_REG_PRIJEMCE_PICKUP' = 'DPD_REG_PRIJEMCE_PICKUP',
'DPD_REG_PRIJEMCE_DROPOFF' = 'DPD_REG_PRIJEMCE_DROPOFF',
'DPD_SK_PICKUP' = 'DPD_SK_PICKUP',
'DPD_SK_DROPOFF' = 'DPD_SK_DROPOFF',
'FOXPOST_RETURNS' = 'FOXPOST_RETURNS',
'GEIS_PICKUP' = 'GEIS_PICKUP',
'GLS_PICKUP' = 'GLS_PICKUP',
'GLS_ISRS' = 'GLS_ISRS',
'GLS_POLAND_API_DROPOFF' = 'GLS_POLAND_API_DROPOFF',
'IN_PERSON' = 'IN_PERSON',
'INPOST_DROP_OFF' = 'INPOST_DROP_OFF',
'INPOST_PICKUP' = 'INPOST_PICKUP',
'LIFTAGO' = 'LIFTAGO',
'MY_GLS_DROP_OFF_CZ' = 'MY_GLS_DROP_OFF_CZ',
'MY_GLS_DROP_OFF_SK' = 'MY_GLS_DROP_OFF_SK',
'MY_GLS_DROP_OFF_HU' = 'MY_GLS_DROP_OFF_HU',
'MY_GLS_BOX_CZ' = 'MY_GLS_BOX_CZ',
'MY_GLS_PICKUP_CZ' = 'MY_GLS_PICKUP_CZ',
'MY_GLS_PICKUP_SK' = 'MY_GLS_PICKUP_SK',
'MY_GLS_PICKUP_HU' = 'MY_GLS_PICKUP_HU',
'MY_GLS_PICKUP_SI' = 'MY_GLS_PICKUP_SI',
'MY_GLS_PICKUP_HR' = 'MY_GLS_PICKUP_HR',
'MY_PPL_PICKUP' = 'MY_PPL_PICKUP',
'PACKETA_CLAIM_ASSISTANT' = 'PACKETA_CLAIM_ASSISTANT',
'MY_PPL_CPL_DROPOFF' = 'MY_PPL_CPL_DROPOFF',
'MY_PPL_CPL_PICKUP' = 'MY_PPL_CPL_PICKUP',
'PPL_RETURN_CONNECT_DROPOFF' = 'PPL_RETURN_CONNECT_DROPOFF',
'PPL_RETURN_CONNECT_PICKUP' = 'PPL_RETURN_CONNECT_PICKUP',
'RABEN_FREIGHT' = 'RABEN_FREIGHT',
'SPS_DROPOFF' = 'SPS_DROPOFF',
'UPS_PICKUP' = 'UPS_PICKUP',
}

export enum ShippingRatingRatingIntuitivityEnum {
'YES' = 'YES',
'MAYBE' = 'MAYBE',
'NO' = 'NO',
}

export enum ShippingRatingRatingSatisfactionEnum {
'VALUE_2' = 2,
'VALUE_1' = 1,
'VALUE_0' = 0,
}

export enum ShippingStatusEnum {
'CONFIRMATION_REQUIRED' = 'CONFIRMATION_REQUIRED',
'WAITING' = 'WAITING',
'SYNCING' = 'SYNCING',
'FINISHED' = 'FINISHED',
'REFUNDED' = 'REFUNDED',
'CANCELED' = 'CANCELED',
'DECLINED' = 'DECLINED',
'FAILURE' = 'FAILURE',
'VOIDED' = 'VOIDED',
}

export enum ShoptetVoucherDiscountTypeEnum {
'FIXED' = 'fixed',
'PERCENTUAL' = 'percentual',
}

export enum SubmitTypeEnum {
'DROP_OFF' = 'DROP_OFF',
'PICKUP' = 'PICKUP',
'FREIGHT' = 'FREIGHT',
'CUSTOM' = 'CUSTOM',
'IN_PERSON' = 'IN_PERSON',
}

export enum TicketFieldEnum {
'ORDER_ID' = 'order_id',
'CUSTOMER_EMAIL' = 'customer_email',
'CUSTOMER_NAME' = 'customer_name',
'CUSTOMER_PHONE' = 'customer_phone',
}

export enum TicketMessageTypeEnum {
'AGENT_MESSAGE' = 'AGENT_MESSAGE',
'CUSTOMER_MESSAGE' = 'CUSTOMER_MESSAGE',
'OTHERS_MESSAGE' = 'OTHERS_MESSAGE',
'EMAIL' = 'EMAIL',
'SMS' = 'SMS',
}

export enum TransportStatusEnum {
'STATUS_PENDING_CONFIRMATION' = 'STATUS_PENDING_CONFIRMATION',
'STATUS_INIT' = 'STATUS_INIT',
'STATUS_ACCEPTED' = 'STATUS_ACCEPTED',
'STATUS_SUBMITTED' = 'STATUS_SUBMITTED',
'STATUS_TRANSPORT' = 'STATUS_TRANSPORT',
'STATUS_DELIVERED' = 'STATUS_DELIVERED',
'STATUS_UNDELIVERED' = 'STATUS_UNDELIVERED',
'STATUS_CANCELED' = 'STATUS_CANCELED',
'STATUS_WAITING_FOR_ORDERING' = 'STATUS_WAITING_FOR_ORDERING',
'STATUS_REFUNDED' = 'STATUS_REFUNDED',
'STATUS_UNKNOWN' = 'STATUS_UNKNOWN',
}

export enum WooCommerceVoucherDiscountTypeEnum {
'FIXED_CART' = 'fixed_cart',
'PERCENT' = 'percent',
'FIXED_PRODUCT' = 'fixed_product',
'PERCENT_PRODUCT' = 'percent_product',
}

export enum YesNoEnum {
'YES' = 'YES',
'NO' = 'NO',
}

}
